'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const HeadingLevelContext = React__default.default.createContext({
  level: 1
});
const useHeadingLevel = () => React__default.default.useContext(HeadingLevelContext);
const HeadingLevelProvider = ({ level = 1, children }) => {
  return React__default.default.createElement(HeadingLevelContext.Provider, { value: {
    level
  } }, children);
};

exports.HeadingLevelProvider = HeadingLevelProvider;
exports.useHeadingLevel = useHeadingLevel;
//# sourceMappingURL=HeadingLevelContext.cjs.js.map
